import { runClientComponent } from '../../_common/client/client-component-runner';
import { ShortInfoComponent } from './short-info.component';

runClientComponent({ ShortInfoComponent: ShortInfoComponent });
